// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes animationRotate {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(1turn);
  }
}
/* Add Animation */
@keyframes animatetop {
  from {
    top: -300px;
    opacity: 0;
  }
  to {
    top: 0;
    opacity: 1;
  }
}
.__playlists__ {
  padding-bottom: 100px;
}
.__playlists__ .__main_padding {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.__playlists__ .__main_padding .__playlists_card {
  margin-top: 40px;
  padding-left: 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 40px;
}
@media (max-width: 576px) {
  .__playlists__ .__main_padding .__playlists_card {
    justify-content: center;
  }
}
.__playlists__ .__main_padding .__playlists_card .__card__add, .__playlists__ .__main_padding .__playlists_card .__card__ {
  height: 150px;
  width: 150px;
}
@media (max-width: 576px) {
  .__playlists__ .__main_padding .__playlists_card .__card__add, .__playlists__ .__main_padding .__playlists_card .__card__ {
    width: 96px;
    height: 96px;
    max-height: 152px;
  }
}
.__playlists__ .__main_padding .__playlists_card .__card__ {
  max-height: 264px;
  border-radius: 6px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/styles/_mixins.scss","webpack://./src/components/SkDrawer/SkDrawerStudio.scss"],"names":[],"mappings":"AAGA;EACE;IACE,oBAAA;ECFF;EDIA;IACE,wBAAA;ECFF;AACF;ADKA,kBAAA;AAYA;EACE;IACE,WAAA;IACA,UAAA;ECJF;EDMA;IACE,MAAA;IACA,UAAA;ECJF;AACF;AA1BA;EACE,qBAAA;AA4BF;AA1BE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AA4BJ;AA1BI;EACE,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,2BAAA;EACA,SAAA;AA4BN;ADPE;EC3BE;IASI,uBAAA;EA6BN;AACF;AA3BM;EACE,aAAA;EACA,YAAA;AA6BR;ADhBE;ECfI;IAKI,WAAA;IACA,YAAA;IACA,iBAAA;EA8BR;AACF;AA3BM;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;AA6BR","sourcesContent":["@import \"./colors.scss\";\n@import \"./breakpoints\";\n\n@keyframes animationRotate {\n  from {\n    transform: rotate(0);\n  }\n  to {\n    transform: rotate(1turn);\n  }\n}\n\n/* Add Animation */\n@-webkit-keyframes animatetop {\n  from {\n    top: -300px;\n    opacity: 0;\n  }\n  to {\n    top: 0;\n    opacity: 1;\n  }\n}\n\n@keyframes animatetop {\n  from {\n    top: -300px;\n    opacity: 0;\n  }\n  to {\n    top: 0;\n    opacity: 1;\n  }\n}\n\n// Small devices\n@mixin sm {\n  @media (max-width: #{$screen-sm-max}) {\n    @content;\n  }\n}\n\n@mixin upToSm {\n  @media (min-width: #{$screen-sm-min}) {\n    @content;\n  }\n}\n\n// Medium devices\n@mixin md {\n  @media (min-width: #{$screen-md-min}) {\n    @content;\n  }\n}\n\n// Large devices\n@mixin lg {\n  @media (min-width: #{$screen-lg-min}) {\n    @content;\n  }\n}\n\n// Extra large devices\n@mixin xl {\n  @media (min-width: #{$screen-xl-min}) {\n    @content;\n  }\n}\n\n// Custom devices\n@mixin rwd($screen) {\n  @media (min-width: #{$screen}px) {\n    @content;\n  }\n}\n\n@mixin screnRange($min, $max) {\n  @media (min-width: #{$min}px) and (max-width: #{$max}px) {\n    @content;\n  }\n}\n\n@mixin screenHeightRange($min, $max) {\n  @media (min-height: #{$min}px) and (max-height: #{$max}px) {\n    @content;\n  }\n}\n","@import \"./../../styles/mixins\";\n\n.__playlists__ {\n  padding-bottom: 100px;\n\n  .__main_padding {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    .__playlists_card {\n      margin-top: 40px;\n      padding-left: 30px;\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: flex-start;\n      gap: 40px;\n\n      @include sm {\n        justify-content: center;\n      }\n\n      .__card__add, .__card__ {\n        height: 150px;\n        width: 150px;\n\n        @include sm {\n          width: 96px;\n          height: 96px;\n          max-height: 152px;\n        }\n      }\n\n      .__card__ {\n        max-height: 264px;\n        border-radius: 6px;\n        cursor: pointer;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
